import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { ProfileComponent } from './profile/profile.component'
import { UrlResolver } from './resolvers/url.resolver'
import { SecYieldPage } from './sec-yield-page/sec-yield-page.component'

const routes: Routes = [
  {
    path: ':tickerOrFundId/sec-yield',
    component: SecYieldPage,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: ':tickerOrFundId',
    component: ProfileComponent,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'investment-products/mutual-funds/profile/:tickerOrFundId/sec-yield',
    component: SecYieldPage,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'investment-products/etfs/profile/:tickerOrFundId/sec-yield',
    component: SecYieldPage,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'accounts-plans/529-plans/profile/:tickerOrFundId/sec-yield',
    component: SecYieldPage,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'investment-products/mutual-funds/profile/:tickerOrFundId',
    component: ProfileComponent,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'investment-products/etfs/profile/:tickerOrFundId',
    component: ProfileComponent,
    resolve: { fundDetails: UrlResolver },
  },
  {
    path: 'accounts-plans/529-plans/profile/:tickerOrFundId',
    component: ProfileComponent,
    resolve: { fundDetails: UrlResolver },
  },
  { path: '**', component: ProfileComponent },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
